import apiClient from '../client';
import type { Scenario, CreateScenarioRequest } from '../../types';

const scenarioService = {
  getAll: async () => {
    const response = await apiClient.get<Scenario[]>('/scenarios');
    return response.data;
  },

  getById: async (id: string) => {
    const response = await apiClient.get<Scenario>(`/scenarios/${id}`);
    return response.data;
  },

  create: async (data: CreateScenarioRequest) => {
    const response = await apiClient.post<Scenario>('/scenarios', data);
    return response.data;
  },

  delete: async (id: string) => {
    await apiClient.delete(`/scenarios/${id}`);
  },
};

export default scenarioService;
